import React, { useRef } from "react"
import { useTranslation } from "react-i18next"

import ListSection from "../components/ListSection"
import SEO from "../components/seo"
import { useSkewOnScroll } from "../hooks/scroll"
import { sortByName } from "../utils/text"

const LITTERAIRE = [
  {
    label: "Adèle Yon",
    url: "",
  },
  {
    label: "Judith Godrèche",
    url: "",
  },
  {
    label: "Nicolas Martin",
    url: "",
  },
  {
    label: "Nicolas Laquerrière",
    url: "",
  },
  {
    label: "Gauthier Plancquaert",
    url: "",
  },
  {
    label: "Camille Fievez",
    url: "",
  },
  {
    label: "Edie Blanchard",
    url: "",
  },
  {
    label: "Nicolas Mathieu",
    url: "",
  },
  {
    label: "Yacha Kurys",
    url: "",
  },
  {
    label: "Benoît Marchisio",
    url: "",
  },
  {
    label: "Xavier Dorison",
    url: "https://fr.wikipedia.org/wiki/Xavier_Dorison",
  },
  {
    label: "Baptiste Fillon",
    url:
      "https://www.agencesartistiques.com/Fiche-Artiste/757560-baptiste-fillon.html",
  },
  {
    label: "Fabien Nury",
    url: "https://www.imdb.com/name/nm1942997/?ref_=fn_al_nm_1",
  },
  {
    label: "Victor Castanet",
    url: "",
  },
].sort(sortByName)

const Litteraire = (): JSX.Element => {
  const containerRef = useRef(null)
  const { t } = useTranslation()

  useSkewOnScroll(containerRef)
  return (
    <>
      <SEO title={t("litteraire")} />
      <div ref={containerRef} style={{ willChange: "transform" }}>
        <ListSection list={LITTERAIRE} id="litteraire" key="litteraire" />
      </div>
    </>
  )
}

export default Litteraire
